import { ApolloError, ApolloQueryResult, useQuery } from "@apollo/client";
import { TemplateHistory } from "src/models/TemplateHistory";

import { GET_TEMPLATE_HISTORY } from "src/operations/queries/getTemplateHistory";
import { GetTemplateHistory } from "src/operations/queries/__generated__/GetTemplateHistory";

export function useTemplateHistory(
    processID: string | undefined
): [
    TemplateHistory | null,
    boolean,
    ApolloError | undefined,
    (variables?: Partial<Record<string, any>> | undefined) => Promise<ApolloQueryResult<GetTemplateHistory>>
] {
    const { data, loading, error, refetch } = useQuery<GetTemplateHistory>(GET_TEMPLATE_HISTORY, {
        variables: {
            processID
        },
        skip: !processID
    });
    return [data ? (data.processHistory as TemplateHistory) : null, loading, error, refetch];
}
